<div class="layout-topbar top-bar-custom">
  <div class="topbar-left">
    <img id="logo-mobile" class="logo-desktop" src="../../../../assets/images/header-white-logo.png" alt="PaperTrl"/>
  </div>
</div>
<div class="exception-body mobile-fields">
  <div class="exception-content">
    <div class="exception-detail">
      <div class="grid">
        <p-card class="card-custom" styleClass="p-card-shadow-remove">
          <div class="card-custom-padding">
            <h5 class="card-header-custom">Create a New Password</h5>
            <div class="p-fluid">
              <form [formGroup]="createNewPasswordForm" (ngSubmit)="create()">

                <div class="col-12">
                  <div class="field margin-between-fields-headers text-align-lef">
                      <span class="p-float-label  p-input-icon-right">
                        <i class="passwordShow" [ngClass]="passwordShow? 'pi pi-eye-slash' : 'pi pi-eye'"
                           (click)="passwordShow? passwordShow= false: passwordShow= true"></i>
                          <input formControlName="password" [feedback]="false" [showPassword]="passwordShow"
                                 class="p-inputtext-lg" id="float-input" type="password"
                                 pPassword>
                          <label for="float-input">Create new password</label>
                      </span>
                    <div class="p-invalid  text-align-left"
                         *ngIf="createNewPasswordForm.get('password').dirty && createNewPasswordForm.get('password').errors">
                      <div *ngIf="createNewPasswordForm.get('password').errors.required">Password is required</div>
                    </div>
                  </div>
                </div>


                <div class="col-12">
                  <div class="field margin-between-fields text-align-left">
                      <span class="p-float-label p-input-icon-right">
                    <i class="passwordShow" [ngClass]="confirmPasswordShow? 'pi pi-eye-slash' : 'pi pi-eye'"
                       (click)="confirmPasswordShow? confirmPasswordShow= false: confirmPasswordShow= true"></i>
                          <input class="p-inputtext-lg" [feedback]="false" [showPassword]="confirmPasswordShow"
                                 formControlName="confirmPassword" id="confirmPassword"
                                 type="password" pPassword>
                          <label for="confirmPassword">Confirm password</label>
                      </span>
                    <div class="p-invalid "
                         *ngIf="createNewPasswordForm.get('confirmPassword').dirty && createNewPasswordForm.get('confirmPassword').errors">
                      <div *ngIf=" createNewPasswordForm.get('confirmPassword').errors.required">Confirm Password is
                        required
                      </div>
                      <div *ngIf=" createNewPasswordForm.get('confirmPassword').errors.mustMatch">New password and
                        Confirm Password must match
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-12 validation-required">
                  <label
                    [ngClass]="createNewPasswordForm.get('password').value && !createNewPasswordForm.controls['password'].hasError('hasSmallCase')  ? 'text-success' : ''">
                    <i
                      [ngClass]="createNewPasswordForm.get('password').value && !createNewPasswordForm.controls['password'].hasError('hasSmallCase') ?  'pi pi-check' : 'empty-icon'"></i>
                    At least one lower case letter [a-z]
                  </label>
                </div>

                <div class="col-12 validation-required">
                  <label
                    [ngClass]="createNewPasswordForm.get('password').value && !createNewPasswordForm.controls['password'].hasError('hasCapitalCase')  ? 'text-success' : ''">
                    <i
                      [ngClass]="createNewPasswordForm.get('password').value && !createNewPasswordForm.controls['password'].hasError('hasCapitalCase') ?  'pi pi-check': 'empty-icon'"></i>
                    At least one upper case letter [A-Z]
                  </label>
                </div>


                <div class="col-12 validation-required">
                  <label
                    [ngClass]="createNewPasswordForm.get('password').value && !createNewPasswordForm.controls['password'].hasError('hasNumber')  ? 'text-success' : ''">
                    <i
                      [ngClass]="createNewPasswordForm.get('password').value && !createNewPasswordForm.controls['password'].hasError('hasNumber') ?  'pi pi-check': 'empty-icon'"></i>
                    At least one numeral [0-9]
                  </label>
                </div>

                <div class="col-12 validation-required">
                  <label
                    [ngClass]="createNewPasswordForm.get('password').value && !createNewPasswordForm.controls['password'].hasError('hasSpecialCharacters')  ? 'text-success' : ''">
                    <i
                      [ngClass]="createNewPasswordForm.get('password').value && !createNewPasswordForm.controls['password'].hasError('hasSpecialCharacters') ?  'pi pi-check': 'empty-icon'"></i>
                    {{"At least one symbol [!@#$%^&*()+,.{}-]"}}
                  </label>
                </div>

                <div class="col-12 validation-required">
                  <label
                    [ngClass]="createNewPasswordForm.get('password').value && !createNewPasswordForm.controls['password'].hasError('minLength')  ? 'text-success' : ''">
                    <i
                      [ngClass]="createNewPasswordForm.get('password').value && !createNewPasswordForm.controls['password'].hasError('minLength') ?  'pi pi-check': 'empty-icon'"></i>
                    Minimum 10 characters
                  </label>
                </div>
                <div class=" col-12 md:col-6 margin-between-fields-input">
                  <p (click)="newToken()" class="req-token">Request New Token</p>
                </div>

                <div class="col-12 md:col-12 margin-between-buttons">
                  <button class="p-button-lg save-btn" [disabled]="createNewPasswordForm.invalid||disableSubmitButton"
                          pButton type="submit" label="SAVE PASSWORD"></button>
                </div>
              </form>
            </div>
          </div>
        </p-card>
      </div>
    </div>
  </div>
</div>

<p-toast position="bottom-right"></p-toast>
